import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { PlatformHelper } from 'src/app/core/helpers/platform.helper';
import { Channel } from 'src/app/core/models/content.model';
import { ILink } from 'src/app/core/models/site.response';

@Component({
  selector: 'air-link-list',
  templateUrl: './link-list.component.html',
  standalone: false
})
export class LinkListComponent {
  private _linkLists: ILink[] = [];
  @Input() get linkLists(): ILink[] {
    const channel = PlatformHelper.isNativeMobile ? Channel.app : Channel.web;
    return this._linkLists?.filter((x) => !x.channels?.length || x.channels.includes(channel)) || [];
  }
  set linkLists(value: ILink[]) {
    this._linkLists = value;
  }
  @Input() userEventSource: string;

  @ViewChild('pageLinks') pageLinksRef: TemplateRef<ElementRef>;

  constructor() {}

  onSectionClick(event: Event): void {
    const target = (event.currentTarget || event.target) as Element;
    target.classList.toggle('section--open');
  }
}
